module.exports = __webpack_public_path__ + "static/media/icon-top.49a7a009.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-top.svg
// module id = 865
// module chunks = 7